import React, { useRef, useEffect, useState, useContext, useReducer, useCallback } from "react";
import {SV_SOJ_SVNAV_BRIDGE} from '../../constants'

import SVTopNavitem from "./SVTopNavitem"
import TacosContainerPage from '../../views/TacosContainerPage'
import {ReguserContainerCom} from '../../containers'
import SVESOrderComPage from '../../views/SVESOrderComPage'
import SVTPOrderComPage from '../../views/SVTPOrderComPage'
import StoredcardsWithCustprofilePage from '../../views/StoredcardsWithCustprofilePage'

import {FANCY_MENU_METADATA} from '../../constants'



import './dinoContainer.css';

function TacosListPage(){
    return <h3>Tacos List Page</h3>;
  
  }
  function Bus() {
    return <h3>Bus</h3>;
  }

export const SVVanillaNav = ({radio_data,onChildClick}, props) => {
    console.log('component refresh1345 radio_data nw')
    console.log(radio_data)
    const navbarUatdemo =  {
      loading: false,
      error: false,
      vanilla_data:[
        {
          selected:false,
          fancyConfig:{
            pufancy :false,
            mychilds:[],
            puto : '/bus'
          },
          icon: "icon-home",
          menuDisp: "COSMOS",
          menuKey: "COSMOS(SVFlights)",
          exact: true,
          path: "/inetcosmos/svflysearch",
          component: "getLazyHome"
        },
        {
          selected:false,
          fancyConfig:{
            pufancy :false,
            mychilds:[],
            puto : '/bus'
          },
          icon: "icon-home",
          menuDisp: "ANALYTICS",
          menuKey: "ANALYTICS(SVFlights)",
          exact: true,
          path: "/inetanalytics/svvissearch",
          component: "getLazyAnalytics"
        },
        {
          selected:false,
          fancyConfig:{
            pufancy :false,
            mychilds:[],
            puto : '/bus'
          },
          icon: "icon-home",
          menuDisp: "COSMOS CRUISES",
          menuKey:"CRUISES(SVCruises)",
          exact: true,
          path: "/inetcruises/svclisearch",
          component: "getLazyCruises"
        },
        {
            selected:false,
            fancyConfig:{
                pufancy :false,
                mychilds:[],
                puto : '/bus'
              },
          icon: "icon-code",
          menuDisp: "Abode",
          menuKey: "Abode",
          exact: true,
          path: "/inetabode/svessearch",
          component: "getLazyCode"
        },
     /*   {
          selected:false,
          fancyConfig:{
              pufancy :false,
              mychilds:[],
              puto : '/bus'
            },
        icon: "icon-code",
        menuDisp: "SJWills",
        menuKey: "SJWills",
        exact: true,
        path: "/isjpb/probate",
        component: "getLazyProbate"
      }, */
        {
          selected:false,
          fancyConfig:{
              pufancy :false,
              mychilds:[],
              puto : '/bus'
            },
        icon: "icon-code",
        menuDisp: "SOJOURNS",
        //menuDisp: "SVSojourns",
        menuKey: "SVSojourns",
        exact: true,
        path: "/inetsojourn/svsojourn",
        component: "getLazySojourn"
      },
        {
            selected:false,
            fancyConfig:{
                pufancy :false,
                mychilds:[
                    {
                      label:  "SVProfie",
                      path: "/myaccountSV/:id/svcustomer",
                      component: ReguserContainerCom
                    },
                    {
                        label:  "SV Storedcard List",
                      path:  "/myaccountSV/:id/mystoredcardList",
                      component: StoredcardsWithCustprofilePage
                    },
                    
                    {
                        label:  "SV MyCosmos List",
                      path: "myaccountSV/:id/svflighttripslist",
                      component: SVTPOrderComPage
                    }
                  ],
                puto : '/bus'
              },
          icon: "icon-data",
          menuDisp: "SVMy Reservations",
          menuKey: "SVMy5Reservations",
          exact: true,
          path: "/svlogin",
          component: "getLazyData"
        }
        
       
      ],
      my_data: [
          {
              "name": "Bob",
              "selected": true,
              "age": 23,
              "species": "T. Rex"
          },
          {
              "name": "Dylan",
              "selected": false,
              "age": 44,
              "species": "Bracchio"
          },
          {
              "name": "Kate",
              "selected": false,
              "age": 32,
              "species": "Stego"
          },
          {
              "name": "Sally",
              "selected": false,
              "age": 13,
              "species": "T. Rex"
          }
      ]
  }
    /*
    let vanilla_data = FANCY_MENU_METADATA
    vanilla_data.push( {
        selected:false,
        fancyConfig:{
            pufancy :false,
            mychilds:[
                {
                  label:  "SVProfie",
                  path: "/myaccountSV/:id/svcustomer",
                  component: ReguserContainerCom
                },
                {
                    label:  "SV Storedcard List",
                  path:  "/myaccountSV/:id/mystoredcardList",
                  component: StoredcardsWithCustprofilePage
                },
                
                {
                    label:  "SV MyCosmos List",
                  path: "myaccountSV/:id/svflighttripslist",
                  component: SVTPOrderComPage
                }
              ],
            puto : '/bus'
          },
      icon: "icon-data",
      menuDisp: "SVMy Reservations",
      menuKey: "SVMy5Reservations",
      exact: true,
      path: "/svlogin",
      component: "getLazyData"
    })
    vanilla_data.push( {
        selected:false,
        fancyConfig:{
            pufancy :true,
            mychilds:[
                {
                  label:  "TacosListPagerFN",
                  path: "/tacos/list",
                  component: TacosListPage
                },
                {
                    label:  "TacosContainerPagerFN",
                  path: "/tacos/:id",
                  component: TacosContainerPage
                },
                
                {
                    label:  "BusFN",
                  path: "/tacos/bus",
                  component: Bus
                }
              ],
            puto : '/bus'
          },
      icon: "icon-jobs",
      menuDisp: "TacosHeader",
      menuKey: "TacosHeader",
      exact: true,
      path: "/tacos",
      component: "getLazyJobs"
    })
    let initialState = {
        loading: false,
        error: false,
        'vanilla_data':vanilla_data,
        my_data: [
            {
                "name": "Bob",
                "selected": true,
                "age": 23,
                "species": "T. Rex"
            },
            {
                "name": "Dylan",
                "selected": false,
                "age": 44,
                "species": "Bracchio"
            },
            {
                "name": "Kate",
                "selected": false,
                "age": 32,
                "species": "Stego"
            },
            {
                "name": "Sally",
                "selected": false,
                "age": 13,
                "species": "T. Rex"
            }
        ]
    }
    */
   const navbarProd =  {
    loading: false,
    error: false,
    vanilla_data:[
        {
          selected:false,
          fancyConfig:{
            pufancy :false,
            mychilds:[],
            puto : '/bus'
          },
          icon: "icon-home",
          menuDisp: "COSMOS",
          menuKey: "COSMOS(SVFlights)",
          exact: true,
          path: "/inetcosmos/svflysearch",
          component: "getLazyHome"
        },
        {
          selected:false,
          fancyConfig:{
            pufancy :false,
            mychilds:[],
            puto : '/bus'
          },
          icon: "icon-home",
          menuDisp: "ANALYTICS",
          menuKey: "ANALYTICS(SVFlights)",
          exact: true,
          path: "/inetanalytics/svvissearch",
          component: "getLazyAnalytics"
        },
        {
          selected:false,
          fancyConfig:{
            pufancy :false,
            mychilds:[],
            puto : '/bus'
          },
          icon: "icon-home",
          menuDisp: "COSMOS CRUISES",
          menuKey:"CRUISES(SVCruises)",
          exact: true,
          path: "/inetcruises/svclisearch",
          component: "getLazyCruises"
        },
       /* {
          selected:false,
          fancyConfig:{
              pufancy :false,
              mychilds:[],
              puto : '/bus'
            },
        icon: "icon-code",
        menuDisp: "SJWills",
        menuKey: "SJWills",
        exact: true,
        path: "/isjpb/probate",
        component: "getLazyProbate"
      }, */
        {
          selected:false,
          fancyConfig:{
              pufancy :false,
              mychilds:[],
              puto : '/bus'
            },
        icon: "icon-code",
        menuDisp: "SOJOURNS",
        //menuDisp: "SVSojourns",
        menuKey: "SVSojourns",
        exact: true,
        path: "/inetsojourn/svsojourn",
        component: "getLazySojourn"
      },
        {
            selected:false,
            fancyConfig:{
                pufancy :false,
                mychilds:[
                    {
                      label:  "SVProfie",
                      path: "/myaccountSV/:id/svcustomer",
                      component: ReguserContainerCom
                    },
                    {
                        label:  "SV Storedcard List",
                      path:  "/myaccountSV/:id/mystoredcardList",
                      component: StoredcardsWithCustprofilePage
                    },
                    
                    {
                        label:  "SV MyCosmos List",
                      path: "myaccountSV/:id/svflighttripslist",
                      component: SVTPOrderComPage
                    }
                  ],
                puto : '/bus'
              },
          icon: "icon-data",
          menuDisp: "SVMy Reservations",
          menuKey: "SVMy5Reservations",
          exact: true,
          path: "/svlogin",
          component: "getLazyData"
        }
      ],
    my_data: [
        {
            "name": "Bob",
            "selected": true,
            "age": 23,
            "species": "T. Rex"
        },
        {
            "name": "Dylan",
            "selected": false,
            "age": 44,
            "species": "Bracchio"
        },
        {
            "name": "Kate",
            "selected": false,
            "age": 32,
            "species": "Stego"
        },
        {
            "name": "Sally",
            "selected": false,
            "age": 13,
            "species": "T. Rex"
        }
    ]
}
    
    let initialState = {
        loading: false,
        error: false,
        vanilla_data:[
            {
              selected:false,
              fancyConfig:{
                pufancy :false,
                mychilds:[],
                puto : '/bus'
              },
              icon: "icon-home",
              menuDisp: "COSMOS",
              menuKey: "COSMOS(SVFlights)",
              exact: true,
              path: "/inetcosmos/svflysearch",
              component: "getLazyHome"
            },
            {
              selected:false,
              fancyConfig:{
                pufancy :false,
                mychilds:[],
                puto : '/bus'
              },
              icon: "icon-home",
              menuDisp: "ANALYTICS",
              menuKey: "ANALYTICS(SVFlights)",
              exact: true,
              path: "/inetanalytics/svvissearch",
              component: "getLazyAnalytics"
            },
            {
              selected:false,
              fancyConfig:{
                pufancy :false,
                mychilds:[],
                puto : '/bus'
              },
              icon: "icon-home",
              menuDisp: "COSMOS CRUISES",
              menuKey:"CRUISES(SVCruises)",
              exact: true,
              path: "/inetcruises/svclisearch",
              component: "getLazyCruises"
            },
            {
                selected:false,
                fancyConfig:{
                    pufancy :false,
                    mychilds:[],
                    puto : '/bus'
                  },
              icon: "icon-code",
              menuDisp: "Abode",
              menuKey: "Abode",
              exact: true,
              path: "/inetabode/svessearch",
              component: "getLazyCode"
            },
           /* {
              selected:false,
              fancyConfig:{
                  pufancy :false,
                  mychilds:[],
                  puto : '/bus'
                },
            icon: "icon-code",
            menuDisp: "SJWills",
            menuKey: "SJWills",
            exact: true,
            path: "/isjpb/probate",
            component: "getLazyProbate"
          }, */
            {
              selected:false,
              fancyConfig:{
                  pufancy :false,
                  mychilds:[],
                  puto : '/bus'
                },
            icon: "icon-code",
            menuDisp: "SOJOURNS",
            //menuDisp: "SVSojourns",
            menuKey: "SVSojourns",
            exact: true,
            path: "/inetsojourn/svsojourn",
            component: "getLazySojourn"
          },
            {
                selected:false,
                fancyConfig:{
                    pufancy :false,
                    mychilds:[
                        {
                          label:  "SVProfie",
                          path: "/myaccountSV/:id/svcustomer",
                          component: ReguserContainerCom
                        },
                        {
                            label:  "SV Storedcard List",
                          path:  "/myaccountSV/:id/mystoredcardList",
                          component: StoredcardsWithCustprofilePage
                        },
                        
                        {
                            label:  "SV MyCosmos List",
                          path: "myaccountSV/:id/svflighttripslist",
                          component: SVTPOrderComPage
                        }
                      ],
                    puto : '/bus'
                  },
              icon: "icon-data",
              menuDisp: "SVMy Reservations",
              menuKey: "SVMy5Reservations",
              exact: true,
              path: "/svlogin",
              component: "getLazyData"
            },
            
            {
                selected:false,
                fancyConfig:{
                    pufancy :true,
                    mychilds:[
                        {
                          label:  "TacosListPagerFN",
                          path: "/tacos/list",
                          component: TacosListPage
                        },
                        {
                            label:  "TacosContainerPagerFN",
                          path: "/tacos/:id",
                          component: TacosContainerPage
                        },
                        
                        {
                            label:  "BusFN",
                          path: "/tacos/bus",
                          component: Bus
                        }
                      ],
                    puto : '/bus'
                  },
              icon: "icon-jobs",
              menuDisp: "TacosHeader",
              menuKey: "TacosHeader",
              exact: true,
              path: "/tacos",
              component: "getLazyJobs"
            }
          ],
        my_data: [
            {
                "name": "Bob",
                "selected": true,
                "age": 23,
                "species": "T. Rex"
            },
            {
                "name": "Dylan",
                "selected": false,
                "age": 44,
                "species": "Bracchio"
            },
            {
                "name": "Kate",
                "selected": false,
                "age": 32,
                "species": "Stego"
            },
            {
                "name": "Sally",
                "selected": false,
                "age": 13,
                "species": "T. Rex"
            }
        ]
    }
  
    if(SV_SOJ_SVNAV_BRIDGE === 'PROD'){
      initialState = navbarProd
    }else if(SV_SOJ_SVNAV_BRIDGE === 'UATDEMO'){
      initialState = navbarUatdemo
    
    }else{
      //do nothing
     // initialState = initialState
    }
    
    const pufancy =(fancy)=>{
        console.log('update State fro SVTopNavItem')
        let f ={
            pufancy :false,
            puto : '/bus'
        }
        f = fancy
       
        

    }
    const getMyHtml = () => {
       /* const radio_data= [
            {
                "name": "1",
                "id": 1,
                "selected": true,
                "age": 23,
                "species": "T. Rex"
            },
            {
                "name": "2",
                "id": 2,
                "selected": false,
                "age": 44,
                "species": "Bracchio"
            },
            {
                "name": "3",
                "id": 3,
                "selected": false,
                "age": 32,
                "species": "Stego"
            },
            {
                "name": "4",
                "id": 4,
                "selected": false,
                "age": 13,
                "species": "T. Rex"
            }
        ]
   */
        return radio_data.map(o => {
            console.log(o)
            if (o.selected === false){
                return        (<div className="c-box">
                <a onClick={ (e)=>{onChildClick(o,e)} }> <span  className="c-span">{o.id}</span></a> 
              </div>)
            }else{
                return        (<div className="c-box">
                <a onClick={ (e)=>{onChildClick(o,e)} }> <span  className="c-span svactive">{o.id}</span></a> 
              </div>)
            }
           
        });
    }
    const getMyVanilaHtml=()=>{

        return initialState.vanilla_data.map( (o,idx)=>{ 
            if(o.selected == false){
                return ( <SVTopNavitem svselected={o.selected} pufancy={o.fancyConfig} to={o.path}> {o.menuDisp} </SVTopNavitem>
                )
            }else{
                return ( <SVTopNavitem {...props} svselected={o.selected} pufancy={o.fancyConfig} to={o.path}> {o.menuDisp} </SVTopNavitem>
               
                )
            }
        })

    }
    return (
        <div className="col-xs-6" style={{"display":"block"}}>
        <ul id="subNavDiv" className="hopper-nav list-horizontal pull-right">
           <li><strong>Open Stack</strong>
            </li>
           
            {getMyVanilaHtml()}
            {/*  
                 <SVTopNavitem pufancy={pufancy} to="/inetcosmos/svflysearch"> COSMOS(SVFlights) </SVTopNavitem>

            <SVTopNavitem pufancy={pufancy} to="/inetabode/svessearch"> Sojourns </SVTopNavitem>
            <SVTopNavitem pufancy={pufancy} to="/svlogin"> SVMy Reservations </SVTopNavitem>

            <SVTopNavitem pufancy={pufancy}  to="/sandwiches"> SandwichesHeader </SVTopNavitem>
            <SVTopNavitem pufancy={pufancy} to="/tacos">TacosHeader </SVTopNavitem>

            */}
           
        
        </ul>
    </div>
    )
}